module.exports = __webpack_public_path__ + "static/img/db55e404c3302c472d5053ea5b0eeddc.165c397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/db55e404c3302c472d5053ea5b0eeddc.jpg
// module id = OUZO
// module chunks = 1